var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LanguagePicker'),_c('div',{attrs:{"id":"app","lang":_vm.$t('lang'),"dir":_vm.$t('dir')}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }